<div *ngIf="canViewGlobalFilters && !loadedFilters">
  <!--Loader-->
  <div class="loader">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>

<ng-container *ngIf="canViewGlobalFilters && loadedFilters">
  <button [@loadedFadeAnimation]="'visible'" type="button" (click)="toggleGlobalFilters()" class="filters-config-toggle" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Configurar filtros globales"><i class="fa fa-cog" aria-hidden="true"></i></button>
  <div class="filters filters-configurator" [ngClass]="{'show': showGlobalFilters}">
    <div class="title mb-3">Configuración de filtros globales</div>
    <div class="row mx-0">
      <div class="col-md-12 box__border mt-2 mt-md-1">
        <div class="cont__filters_fields row row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
          <div class="col mb-3">
            <label class="form-label">Año</label>
            <select2 [(ngModel)]="yearSelected" placeholder="Seleccionar año" [data]="yearData || []"></select2>
          </div>
          <div class="col mb-3">
            <label class="form-label">Mes</label>
            <select2 [(ngModel)]="monthSelected" placeholder="Seleccionar mes" [data]="monthData || []"></select2>
          </div>
          <app-distributor-common-filter [inputFilter]="distributorFilters" [idBrand]="'0'" [selectOnChange]="true" (modelFilterEmit)="getDistributorFilter($event)" [hideDr]="true" [hideSector]="true" [hideVnPlate]="true" [hidePvGroup]="true" [hideResetFilter]="true" class="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3"></app-distributor-common-filter>
          <div class="col mb-3">
            <label class="form-label">Marca</label>
            <select2 [(ngModel)]="brandSelected" [multiple]="true" placeholder="Seleccionar marca" [data]="brandData || []">
            </select2>
          </div>
          <div class="col mb-3">
            <label class="form-label">Pago</label>
            <select2 [(ngModel)]="paymentSelected" placeholder="Seleccionar pago" [data]="paymentData || []"></select2>
          </div>
          <div class="col mb-3">
            <label class="form-label">Actividad</label>
            <select2 [(ngModel)]="activitySelected" placeholder="Seleccionar tipo" [data]="activityData || []"></select2>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1 align-items-baseline">
      <div class="col align-self-end mb-3 text-end">
        <button type="button" class="btn btn-secondary-action" (click)="filter()">Guardar filtros globales</button>
      </div>
    </div>
  </div>
</ng-container>